import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { IMAGES } from "../mock";

const Hero = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState("buy");
  const [query, setQuery] = useState("");

  const handleSearch = (e) => {
    e.preventDefault();
    const dest = tab === "buy" ? "/buying" : "/lettings";
    navigate(`${dest}?q=${encodeURIComponent(query)}`);
  };

  return (
    <section className="relative min-h-[88vh] flex items-center justify-center">
      <div className="absolute inset-0">
        <img src={IMAGES.hero} alt="Bath Georgian architecture" className="w-full h-full object-cover" />
        {/* Stronger legibility scrim: vertical gradient + centred radial vignette */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
        <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse 70% 55% at 50% 45%, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.15) 55%, rgba(0,0,0,0) 80%)" }} />
      </div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-5 text-center fade-up [text-shadow:0_2px_18px_rgba(0,0,0,0.45)]">
        <div className="flex items-center justify-center gap-3 mb-6">
          <span className="w-8 h-[1px] bg-[#d9b98a]" />
          <span className="text-[12px] tracking-[0.28em] uppercase text-[#e8d4b8]">Welcome to Anadear Estates</span>
          <span className="w-8 h-[1px] bg-[#d9b98a]" />
        </div>
        <h1 className="font-display text-white text-[42px] md:text-[62px] leading-[1.08] font-300 mb-6">
          Bath's Trusted Local<br />Property Experts
        </h1>
        <p className="text-white/90 text-[15px] md:text-[17px] leading-relaxed max-w-[640px] mx-auto mb-10 font-300">
          At Anadear Estates, we combine deep local knowledge with a passion for property.
          Whether you're buying, selling, or investing in Bath or Bristol, our experienced team
          is here to guide you every step of the way.
        </p>

        <div className="max-w-[620px] mx-auto">
          <div className="flex items-center justify-center gap-8 mb-4">
            {["buy", "rent"].map((t) => (
              <button
                key={t}
                onClick={() => setTab(t)}
                className={`text-[15px] pb-2 capitalize transition-colors relative ${
                  tab === t ? "text-white" : "text-white/60 hover:text-white/90"
                }`}
              >
                {t}
                {tab === t && <span className="absolute bottom-0 left-0 w-full h-[2px] bg-[#b8935f]" />}
              </button>
            ))}
          </div>
          <form onSubmit={handleSearch} className="relative">
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search area or postcode"
              className="w-full h-[60px] pl-6 pr-16 rounded-full bg-white text-[15px] text-[#2b2b2b] placeholder:text-[#9a9a9a] outline-none shadow-[0_10px_40px_rgba(0,0,0,0.2)] focus:ring-2 focus:ring-[#b8935f]/40"
            />
            <button
              type="submit"
              aria-label="Search"
              className="absolute right-2.5 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-[#b8935f] flex items-center justify-center hover:bg-[#a67f4d] transition-colors"
            >
              <Search size={19} className="text-white" />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Hero;
